import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {MdcFloatingLabelModule} from '@shraddhar/mdc-test-web/floating-label';
import {MdcLineRippleModule} from '@shraddhar/mdc-test-web/line-ripple';
import {MdcNotchedOutlineModule} from '@shraddhar/mdc-test-web/notched-outline';
import {MdcFormFieldModule} from '@shraddhar/mdc-test-web/form-field';
import {MdcMenuModule} from '@shraddhar/mdc-test-web/menu';
import {MdcListModule} from '@shraddhar/mdc-test-web/list';

import {MdcSelect} from './select';
import {MdcSelectIcon} from './select-icon';

const SELECT_DECLARATIONS = [
  MdcSelect,
  MdcSelectIcon,
];

@NgModule({
  imports: [
    CommonModule,
    MdcMenuModule,
    MdcListModule,
    MdcFormFieldModule,
    MdcFloatingLabelModule,
    MdcNotchedOutlineModule,
    MdcLineRippleModule
  ],
  exports: [
    MdcMenuModule,
    MdcListModule,
    MdcFormFieldModule,
    SELECT_DECLARATIONS
  ],
  declarations: SELECT_DECLARATIONS
})
export class MdcSelectModule {}
